export class TermsArray {
    id: string
    isAccepted: boolean
    isRenewed: boolean
    link: string
    modifyDate: number
    msaName: string
    name: string
}



// WEBPACK FOOTER //
// ./src/types/TermsArray.ts